<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto d-flex flex-column justify-center align-center" v-if="cardList !== false && cardList.length == 0">
        <div class="text-center">
            <v-img src="@/assets/img/workingshift.svg" aspect-ratio="16/9" max-width="600" class="mx-auto"></v-img>
            <h4 class="text-primary my-5 font-weight-bold">شيفت هاي كاري</h4>
            <p class="text-grey-darken-1 text-meta my-4">یکی از ویژگی‌های مهم سامانه هلپیکال، قابلیت تعریف شیفت‌های کاری مختلف برای سازمان شماست.<br>با اختصاص شیفت‌های کاری به دپارتمان‌ها و کاربران سازمانی می‌توانید از قوانین SLA که یکی از ابزارهای حرفه‌ای هلپیکال می‌باشد استفاده کنید.</p>
            <v-btn @click="$router.push({path: '/settings/workingShift/new' })" color="primary" class="mt-1"><v-icon class="me-1">add</v-icon>شیفت جدید</v-btn>
        </div>
    </div>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto" v-else-if="cardList !== false">
        <v-col xl="4" lg="6" md="7" sm="9" cols="12">
            <p class="text-primary font-weight-bold mb-2">ليست شيفت‌های کاری</p>
            <p class="text-meta text-grey-darken-1">یکی از ویژگی‌های مهم سامانه هلپیکال، قابلیت تعریف شیفت‌های کاری مختلف برای سازمان شماست.<br>با اختصاص شیفت‌های کاری به دپارتمان‌ها و کاربران سازمانی می‌توانید از قوانین SLA که یکی از ابزارهای حرفه‌ای هلپیکال می‌باشد استفاده کنید.</p>
            <v-btn color="primary" class="my-2" @click="$router.push({path: '/settings/workingShift/new' })" v-if="$auth.user.full_admin">
                <v-icon class="me-1">add</v-icon>شیفت جدید
            </v-btn>
            <workingShiftCard
                :lists="cardList"
                @deleteCard="deleteList"
                icon="icon-clock"
                @editCard="(id) => this.$router.push({path: `/settings/workingShift/${id}`})"
                :showActions="{editable:$auth.user.full_admin,deletable:$auth.user.full_admin}"
                :showDetails="false"
            ></workingShiftCard>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "شيفت‌هاي كاري",
    validate(context) {
        return context.auth.user.full_admin && context.system.license.features.workingshift;
    },
    data() {
        return {
            cardList: false,
        };
    },
    methods: {
        deleteList(id) {
            this.$loading.start();
            this.$workingShiftDelete(id).then(async (res) => {
                if (res && res.status == "DELETED") {
                    await this.getWorkingshifts();
                    this.$toast.success(res.message);
                }
            }).finally(() => this.$loading.finish());
        },
        async getWorkingshifts() {
            await this.$workingShiftList().then((res) => {
                if (res && res.status == "OK") this.cardList = res.data;
            });
        }
    },
    mounted() {
        this.$nextTick(async () => {
            this.$loading.start();
            await this.getWorkingshifts();
            this.$loading.finish();
        });
    },
};
</script>
